export default "/assets/images/outdoor-air-tracking.fb754a78a6f612a7.jpg";